import React, {Component} from 'react'
import {Col, DatePicker, Form, Icon, Input, Modal, Row, Select, Upload, Cascader, Radio, Button, Badge, Spin, Table, Popover, Pagination} from "antd"
import {api, app} from "../../app"
import OpeningInfo from "./OpeningInfo"
import config from "../../config";
import { Link } from 'react-router-dom'
import moment from "moment"
import PayTemplate from "../../components/PayTemplate"

const Option = Select.Option
const FormItem = Form.Item
const RadioGroup = Radio.Group

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

class SuNearby extends Component {
    constructor(props) {
        super(props);
        this.state = {
            region_id:'',
            opening_modal:false,
            subject_id:'',
            opening_title:'',
            up_loading:false,
            regionsList:[],
            classData:[],
            is_submit:0,
            update_loading:false,
            pay_method:'',
            guidance_url:'',
            regionsLists:[],
            total: 0,
            page: 1,
            dataList:[],
            item:[],
            is_apply:3
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.rcList()
        await this.regionsDatas(1)
        await this.regionsData()
        await this.guidance()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 图片上传变更
     * @param info
     */
    handleImgUploadChage = ({ file }) => {
        if (file.status === 'uploading') {
            this.setData({ up_loading: true });
            return;
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.setData({ up_img: file.response.data.url, up_loading: false });
        }
    };

    /**
     * 选择省份
     */
    onSelect = async (obj) => {
        //this.props.form.resetFields(['name','idno','sex','images','mobile','birthdate','mail_city','mail_address',[]]);//清空表单
        //await this.setData({ opening_title:obj.props.children, up_img:'', is_submit:0 })
        if(obj.count == '0'){
            await this.setData({ subject_id:'',opening_title:obj.region_name,is_apply:1 })
            return
        }
        await this.setData({ opening_title:obj.region_name,is_apply:2 })
        await this.handleOpenOpeningModal(obj.region_id)
    }

    /**
     * 打开近期开班详情
     */
    recentOpeningModal = async (obj) => {
        await this.setData({ recent_title:obj.train_name, recent_modal: true, item:obj })
    }

    /**
     * 关闭近期开班详情
     */
    recentCloseModal = async (obj) => {
        await this.setData({ recent_modal: false, item:[] })
    }

    /**
     * 打开开班信息
     */
    handleOpenOpeningModal = async (id) => {
        await this.setData({ region_id: id,opening_modal: true })
    }

    /**
     * 关闭开班信息
     */
    handleCloseOpeningModal = async (obj) =>{
        if(obj.subject_id){
            await this.setData({subject_id:obj.subject_id, classData:obj.opening_data, opening_modal: false })
        }else{
            await this.setData({ subject_id:'', classData:[], opening_modal: false })
        }
    }

    /**
     * 获取地区信息
     */
    onChangeRegions = async (value) => {
        console.log(value)
    }

    /**
     * 勾选须知
     */
    onChangeRadio = async (e) => {
        await this.setData({ is_submit: e.target.value })
    }

    /**
     * 支付方式
     */
    onChangePay = async (e) => {
        await this.setData({ pay_method: e.target.value })
    }

    /**
     * 地区数据
     **/
    regionsDatas = async (type) => {
        await this.setData({ regions_loadings: true })
        let params = {
            type:type
        }
        let { flag, data, msg } = await app.post(api.SkillTrainRegions,params)
        let state = { regions_loadings: false },
            arr = ['710000','810000','820000']
        if (flag === 1) {
            data.map((item,index) => {
                if(arr.includes(item.region_id)){
                    if(!data[index].disabled){
                        data[index].disabled = true
                    }
                }
            })
            state.regionsLists = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 地区数据
     **/
    regionsData = async () => {
        await this.setData({ regions_loading: true })
        let { flag, data, msg } = await app.post(api.SkillTrainRegions)
        let state = { regions_loading: false },
            arr = ['710000','810000','820000']
        if (flag === 1) {
            data.map((item,index) => {
                if(arr.includes(item.region_id)){
                    if(!data[index].disabled){
                        data[index].disabled = true
                    }
                }
            })
            state.regionsList = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 报名须知
     **/
    guidance = async () => {
        await this.setData({ guidance_loading: true })
        let { flag, data, msg } = await app.post(api.SkillTrainGuidance)
        let state = { guidance_loading: false }
        if (flag === 1) {
            state.guidance_url = data.url
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 提交
     **/
    handleAdd = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (err) {
                return;
            }
            const {subject_id, up_img, update_loading, is_submit, pay_method} = this.state,
                params = {
                    subject_id: subject_id,
                    images: up_img,
                    name: values.name,
                    idno: values.idno,
                    sex: values.sex,
                    mobile: values.mobile,
                    birthdate: moment(values.birthdate).format("YYYY-MM-DD"),
                    mail_province: values.mail_region[0],
                    mail_city: values.mail_region[1],
                    mail_district: values.mail_region[2],
                    mail_address: values.mail_address,
                    pay_method:pay_method
                }
            if (update_loading) return false
            if (!subject_id) {
                app.alert("请选择你的班级", 'error')
                return
            }
            if (!up_img) {
                app.alert("请上传您的头像照片", 'error')
                return
            }
            if(!params.mail_province){
                app.alert("请选择证书邮寄的省份", 'error')
                return
            }else if(!params.mail_city){
                app.alert("请选择证书邮寄的城市", 'error')
                return
            }else if(!params.mail_district){
                app.alert("请选择证书邮寄的地区", 'error')
                return
            }
            if(!pay_method){
                app.alert("请选择付款方式", 'error')
                return
            }
            if (is_submit != 1) {
                app.alert("请勾选我已阅读《报名须知》", 'error')
                return
            }

            await this.setData({update_loading: true})
            const { flag, data, msg } = await app.post(api.SkillTrainNeighBouring, params)
            app.alertDestroy()
            if (flag === 1) {
                Modal.confirm({
                    title: '扫码支付',
                    centered: true,
                    icon: pay_method==2?(<Icon type="alipay-circle" style={{ color: '#00A1E9' }} />):(<Icon type="wechat" style={{color: '#00D30C'}}/>),
                    width: 600,
                    content: pay_method==2?(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} />):(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} terminal="微信" />),
                    okText: '已支付',
                    cancelText: '关闭',
                    onOk: async () => {
                        const { flag, msg } = await app.post(api.SkillTrainConfirmPay, {
                            orders_no: data.ordersNo
                        })
                        if (flag === 1) {
                            app.alert('支付成功', 'success')
                            this.props.history.push({
                                pathname: '/skillTrain/mtList',
                                state: {
                                    name:values.name,
                                    idno:values.idno
                                }
                            })
                            return true
                        } else {
                            app.alert(msg, 'warn')
                            throw false
                        }
                    }
                })
            } else {
                app.alert(msg, 'warn')
            }
            await this.setData({ update_loading: false })
        })
    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    /**
     * 近期开班列表
     */
    rcList = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let params = {
            page,
        }
        let { flag, data, msg, total } = await app.post(api.SkillTrainRecentClass, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: data, data_loading: false, total: Number(total || 0) })
    }

    //传值父组件
    parentTab = () => {
        this.props.parent({sel_tab:'2'});
    }

    // 培训状态名
    trainStatusName = (e) => {
        switch (e) {
            case '0':
                return '未开始'
                break;
            case '1':
                return '进行中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    applyName = (e) => {
        switch (e) {
            case '1':
                return '报名中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let {item,page,total,dataList,data_loading,recent_modal,recent_title,opening_modal,opening_title,region_id,subject_id,up_img,up_loading,regionsList,regionsLists,classData,is_submit,update_loading,guidance_url,regions_loadings,is_apply} = this.state
        let { form } = this.props,
        { getFieldDecorator } = form,
        formItemLayout = {
            labelAlign: 'left',
            labelCol: { span: 4, offset: 2 },
            wrapperCol: { span: 16},
        },
        columns = [
            {
                title: '开班城市',
                dataIndex: 'province_name',
                key: 'province_name',
                width:256,
                render (province, record) {
                    return province + record.city_name
                }
            },
            {
                title: '培训科目',
                dataIndex: 'names',
                key: 'names',
                width:256
            },
            {
                title: '发证机构',
                dataIndex: 'organization_name',
                key: 'organization_name',
                width:256
            },
            {
                title: '培训天数',
                dataIndex: 'train_day',
                key: 'train_day',
                width:140
            },
            {
                title: '考评天数',
                dataIndex: 'evaluate_day',
                key: 'evaluate_day',
                width:140
            },
            {
                title: '培训总费用（元）',
                dataIndex: 'train_amount',
                key: 'train_amount',
                width:140
            },
            {
                title: '报名状态',
                dataIndex: 'apply_status',
                key: 'apply_status',
                width:140,
                render (status) {
                    switch (status) {
                        case '1':
                            return '报名中'
                            break;
                        case '2':
                            return '已结束'
                            break;
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'class_id',
                key: 'class_id',
                width:140,
                render: (id,obj) => {
                    return (
                        <span>
                            {obj.apply_status === '1'?
                                <Button onClick={() => this.recentOpeningModal(obj)} type="primary" size="large">我要报名</Button>
                                :null}
                        </span>
                    )
                }
            }
        ]
        return(
            <div className="su-nearby">
                {is_apply == 3 || is_apply == 1?
                    <div>
                        <div style={{margin:'20px 0',fontSize:32,fontWeight:'bold',textAlign:'center'}}>近期开班</div>
                        <Table size="small"
                               locale={app.tbLocale(data_loading)}
                               columns={columns}
                               dataSource={dataList}
                               loading={data_loading}
                               rowKey={record => record.class_id}
                               pagination={{
                                   current: page,
                                   total,
                                   pageSize: 20,
                                   showTotal: (t) => `总数量：${t}`,
                                   onChange: this.rcList
                               }}
                               scroll={{x:'max-content',y:297}}
                        >
                        </Table>
                    </div>
                :null}
                {/*<div style={{padding:'20px 0',fontSize:32,fontWeight:'bold',textAlign:'center',borderTop:'4px solid #1890ff'}}>报名附近班</div>*/}
                {/*<div className="select-province">*/}
                {/*    <Row>*/}
                {/*        {regions_loadings?(<div className="mall-loading"><Spin size="large"/></div>):*/}
                {/*            regionsLists.map((b,k) => {*/}
                {/*                return (*/}
                {/*                    <Col className="col-pro" key={k} span={2}>*/}
                {/*                        <Badge count={b.count || 0}>*/}
                {/*                            <Button onClick={() =>this.onSelect(b)} block>{b.region_name}</Button>*/}
                {/*                        </Badge>*/}
                {/*                    </Col>*/}
                {/*                )*/}
                {/*            })*/}
                {/*        }*/}
                {/*        <Col span={24} style={{padding:'20px 0',fontSize:20,textAlign:'center',color:'#E49E0C'}}>请选择需要报名的省份/直辖市</Col>*/}
                {/*    </Row>*/}
                {/*</div>*/}
                {is_apply == 1?''
                    // <div style={{padding:'20px 0',fontSize:20,textAlign:'center'}}>
                    //     【{opening_title}】暂无开班信息
                    //     <a onClick={()=>this.parentTab()}>申请开班</a>
                    // </div>
                :null}
                <Form {...formItemLayout} onSubmit={this.handleAdd}>
                    {subject_id?
                        <div className="train-info">
                            <div className="su-nearby-title">培训信息</div>
                            <div className="train-info-data back-padding">
                                <FormItem label="期望开班城市">
                                    <Input disabled={true} value={classData.province_name + '/' + classData.city_name}/>
                                </FormItem>
                                <FormItem label="培训课程">
                                    <Input disabled={true} value={classData.train_name}/>
                                </FormItem>
                                <FormItem label="培训科目">
                                    <Input disabled={true} value={classData.names}/>
                                </FormItem>
                                {/*<Row className="margin-bot">*/}
                                {/*    <Col className="font-left" span={15} offset={2}>招生人数（满60人即可开班）</Col>*/}
                                {/*    <Col className="font-right" span={5}>{classData.train_number}人</Col>*/}
                                {/*</Row>*/}
                                {classData.apply_count > 10 ?
                                    <Row className="margin-bot">
                                        <Col className="font-left" span={10} offset={2}>已报名人数</Col>
                                        <Col className="font-right" span={10}>{classData.status_name}</Col>
                                    </Row>
                                :null}
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训天数</Col>
                                    <Col className="font-right" span={5}>{classData.train_day}天</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>考评天数</Col>
                                    <Col className="font-right" span={5}>{classData.evaluate_day}天</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训费用</Col>
                                    <Col className="font-right" span={5}>{classData.train_money}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>考评费用</Col>
                                    <Col className="font-right" span={5}>{classData.evaluate_money}元</Col>
                                </Row>
                            </div>
                            <div className="su-nearby-title">个人信息</div>
                            <div className="info-data back-padding">
                                <Row type="flex" justify="center">
                                    <Col style={{ width: 110, textAlign: 'center' }}>
                                        <Upload action={config.serverUrl + api.ImageUpload}
                                                accept='image/jpeg, image/jpg, image/png'
                                                data={{
                                                    upload_type: 'ppe_train',
                                                }}
                                                name="image"
                                                onChange={this.handleImgUploadChage}
                                                beforeUpload={beforeUpload}
                                                listType="picture-card"
                                                showUploadList={false}
                                        >
                                            {up_img ?
                                                <img src={config.imgUrl + up_img} style={{ width: '100%' }} alt="头像" className="avatar"/> :
                                                (
                                                    <div>
                                                        <Icon type={up_loading ? 'loading' : 'plus'}/>
                                                        <div className="ant-upload-text">2寸免冠彩照</div>
                                                    </div>
                                                )}
                                        </Upload>
                                    </Col>
                                </Row>
                                <Row>
                                    <div style={{ textAlign: 'center', marginBottom:'25px'}}>头像用于制作技能证书</div>
                                </Row>
                                <FormItem label="姓名">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入姓名!' }],
                                    })(
                                        <Input placeholder="请输入姓名"/>
                                    )}
                                </FormItem>
                                <FormItem label="身份证号码">
                                    {getFieldDecorator('idno', {
                                        rules: [{ required: true, message: '请输入身份证号码!' }],
                                    })(
                                        <Input placeholder="请输入身份证号码"/>
                                    )}
                                </FormItem>
                                <FormItem label="性别">
                                    {getFieldDecorator('sex', {
                                        rules: [{ required: true, message: '请选择性别！' }],
                                    })(
                                        <Select placeholder="请选择性别">
                                            <Option value="男">男</Option>
                                            <Option value="女">女</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem label="手机号码">
                                    {getFieldDecorator('mobile', {
                                        rules: [{ required: true, message: '请输入手机号码!' }],
                                    })(
                                        <Input placeholder="请输入手机号码"/>
                                    )}
                                </FormItem>
                                <FormItem label="出生年月日">
                                    {getFieldDecorator('birthdate', {
                                        rules: [{ required: true, message: '请选择您的生日!' }]
                                    })(
                                        <DatePicker placeholder="请选择您的生日" />
                                    )}
                                </FormItem>
                            </div>
                            <div className="su-nearby-title">证书邮寄地址</div>
                            <div className="mailing-address back-padding">
                                <FormItem label="证书邮寄所属地区">
                                    {getFieldDecorator('mail_region', {
                                        rules: [{
                                            required: true, message: '请选择证书邮寄所属地区!',
                                        }],
                                    })(
                                        <Cascader
                                            options={regionsList}
                                            onChange={this.onChangeRegions}
                                            placeholder="选择城市"
                                            fieldNames={{ label: 'region_name', value: 'region_name', children: 'sublevel' }}
                                            notFoundContent="无记录"
                                            showSearch={this.filter}
                                        />
                                    )}
                                </FormItem>
                                <FormItem label="证书邮寄详细地址">
                                    {getFieldDecorator('mail_address', {
                                        rules: [{ required: true, message: '请输入证书邮寄详细地址!' }],
                                    })(
                                        <Input placeholder="请输入证书邮寄详细地址"/>
                                    )}
                                </FormItem>
                            </div>
                            <div className="su-nearby-title">培训费用</div>
                            <div className="train-cost back-padding">
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训总费用</Col>
                                    <Col className="font-right black bold" span={5}>{classData.train_amount}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>预报名费（报名预交{classData.beforehand_money}元，可抵{classData.beforehand_money}元培训费）</Col>
                                    <Col className="font-right red bold" span={5}>{classData.beforehand_money}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>支付方式</Col>
                                    <Col className="font-right" span={5}>在线支付</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={10} offset={2}>付款方式</Col>
                                    <Col className="font-right" span={10}>
                                        <RadioGroup onChange={this.onChangePay}>
                                            <Radio value={1}>微信</Radio>
                                            <Radio className="pay-ali" style={{marginRight:'0'}} value={2}>支付宝</Radio>
                                        </RadioGroup>
                                    </Col>
                                </Row>
                            </div>
                            <div className="train-notice">
                                <Row type="flex" className="read-notice">
                                    <Col>
                                        <RadioGroup onChange={this.onChangeRadio} value={is_submit}>
                                            <Radio value={1}></Radio>
                                        </RadioGroup>
                                    </Col>
                                    <Col style={{lineHeight:'27px'}}><a href={config.imgUrl+guidance_url} target="_blank">我已详细阅读《报名须知》</a></Col>
                                </Row>
                                <Row>
                                    <span className="red bold">本次培训为自愿报名！</span>
                                    <span>每人报名时先预交报名费用，剩余费用开班前支付完成；报名人数满即可开班，班级人数不足开班需求人数的报名人员可申请转就近班培训</span>
                                </Row>
                                <Row type="flex" justify="center" className="info-submit">
                                    <Col span={6}>
                                        <Button size="large" type="primary" htmlType="submit" loading={update_loading} block>确认报名</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        :null
                    }
                </Form>
                <Modal
                    visible={opening_modal}
                    title={'【'+opening_title+'】已申请开班信息'}
                    footer={null}
                    width="70%"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleCloseOpeningModal}
                    bodyStyle={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}
                    style={{ paddingBottom: 0, top: 70 }}
                    className="opening-info-modal-class"
                >
                    <OpeningInfo region_id={region_id} onClose={this.handleCloseOpeningModal}/>
                </Modal>
                <Modal
                    visible={recent_modal}
                    title={recent_title}
                    footer={null}
                    width="50%"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.recentCloseModal}
                    bodyStyle={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}
                    style={{ paddingBottom: 0, top: 70 }}
                    className="list-data-modal-class"
                >
                    <div className="list-data-r">
                        <Row type="flex" justify="center">
                            <Col span={11}>
                                <Row>
                                    <Col className="list-data-c" span={24}>开班城市：{item.province_name}/{item.city_name}</Col>
                                    <Col className="list-data-c" span={24}>培训课程：{item.train_name}</Col>
                                    <Col className="list-data-c" span={24}>培训科目：{item.names}</Col>
                                    <Col className="list-data-c" span={24}>科目班级：{item.train_class_name}</Col>
                                    <Col className="list-data-c" span={24}>报到时间：{item.check_date}</Col>
                                    <Col className="list-data-c" span={24}>培训时间：{item.start_date}~{item.end_date}</Col>
                                    <Col className="list-data-c" span={24}>考评时间：{item.evaluate_start_date}~{item.evaluate_end_date}</Col>
                                    <Col className="list-data-c" span={24}>考试地点：{item.evaluate_address}</Col>
                                    <Col className="list-data-c" span={24}>发证机构：{item.organization_name}</Col>
                                </Row>
                            </Col>
                            <Col span={11}>
                                <div className="list-data-right">
                                    <Row>
                                        <Col className="list-data-c" span={12} offset={12}>招生人数：{item.train_number}人</Col>
                                        <Col className="list-data-c" span={12} offset={12}>培训天数：{item.train_day}天</Col>
                                        <Col className="list-data-c" span={12} offset={12}>考评天数：{item.evaluate_day}天</Col>
                                        <Col className="list-data-c" span={12} offset={12}>考评费用：{item.evaluate_money}元</Col>
                                        <Col className="list-data-c" span={12} offset={12}>培训费用：{item.train_money}元</Col>
                                        <Col className="list-data-c" span={12} offset={12}>培训总费用：{item.train_amount}元</Col>
                                        <Col className="list-data-c" span={12} offset={12}>培训状态：{this.trainStatusName(item.train_status)}</Col>
                                        <Col className="list-data-c" span={12} offset={12}>报名状态：{this.applyName(item.apply_status)}</Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col span={24}>
                                <hr/>
                                <div style={{margin:'20px 0',fontSize:20,fontWeight:'bold',textAlign:'center'}}>微信扫一扫报名</div>
                                <div style={{textAlign:'center'}}><img style={{width:250,}} src={config.imgUrl+item.qrCode_url}/></div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default Form.create()(SuNearby);



// WEBPACK FOOTER //
// ./src/routes/skillTrain/SuNearby.jsx